import * as actionTypes from "./EmailType";

const INITIAL_STATE = {
    credentialList: [],
    contentList: []
};

const EmailReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETCREDENTIALLIST:
            return {
                ...state,
                credentialList: action.payload.list,
            };
        case actionTypes.SETCONTENTLIST:
            return {
                ...state,
                contentList: action.payload.list,
            };
        default:
            return state;
    }
}

export default EmailReducer;